import type { ReactNode } from 'react';
import { SubTabs, type SubTab } from './SubTabs';
import { cn } from '../utils/cn';

// =============================================================================
// PageTitle — 모든 메뉴의 머리 부분을 한 모양으로 (2026-09-14 결정).
//
//   [제목 ............................ 액션 버튼]
//   [탭 · 탭 · 탭]                      ← 탭이 있는 메뉴(조직 관리·고객사 상세·운영사)만
//
// 브레드크럼(작은 글씨)과 메뉴 설명 문구는 두지 않는다. 제목은 좌측 네비 라벨과 같은 말을 쓴다.
//
// 제목 위치 고정(C-1 3차): 액션 버튼(41px)이 있으면 items-center 때문에 제목이 2~3px 내려가
// 메뉴마다 제목 높이가 달라 보였다. 제목은 36px 줄높이로 컨테이너 상단에 붙이고(items-start),
// 버튼만 그 36px 안에서 가운데 맞춘다.
// =============================================================================

export function PageTitle({
  title,
  actions,
  tabs,
  className,
}: {
  title: ReactNode;
  actions?: ReactNode | undefined;
  tabs?: SubTab[] | undefined;
  className?: string | undefined;
}): JSX.Element {
  return (
    <header className={cn('mb-4 flex flex-col gap-3', className)}>
      <div className="flex min-h-[36px] flex-wrap items-start justify-between gap-3">
        <h1 className="text-[22px] font-bold leading-9 tracking-[-0.01em] text-text">{title}</h1>
        {actions && <div className="flex min-h-[36px] flex-wrap items-center gap-2 md:shrink-0">{actions}</div>}
      </div>
      {tabs && tabs.length > 0 && <SubTabs tabs={tabs} className="border-b-0 bg-transparent px-0 py-0" />}
    </header>
  );
}
